var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseSelect',{attrs:{"value":_vm.currentFilter,"options":_vm.filterItems,"defaultText":"generals.sort"},on:{"input":_vm.sortFunc}})}
var staticRenderFns = []

export { render, staticRenderFns }